import { h } from 'vue';
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import '@mdi/font/css/materialdesignicons.css';

function isMdiIcon(icon) {
  if (!icon || typeof icon !== 'string') {
    return false;
  }
  const name = icon.startsWith('mdi:') ? icon.slice(4) : icon;
  return name.startsWith('mdi-') || Object.prototype.hasOwnProperty.call(aliases, name);
}

const hybridIcons = {
  component: (props) => {
    const icon = props.icon;
    if (!icon) {
      return null;
    }

    if (isMdiIcon(icon)) {
      const mdiIcon = icon.startsWith('mdi:') ? icon.slice(4) : icon;
      return mdi.component({
        ...props,
        icon: mdiIcon,
      });
    }

    return h(props.tag || 'i', {
      class: icon,
      'aria-hidden': true,
    });
  },
};

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'hybrid',
    aliases,
    sets: {
      hybrid: hybridIcons,
      mdi,
    },
  },
  theme: {
    themes: {
      light: {
        colors: {
          primary: '#1976D2',
          secondary: '#424242',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FB8C00',
        },
      },
    },
  },
});
